var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.accommodation)?_c('v-container',{staticClass:"pa-0 accommodation-map-container"},[_c('v-container',{staticClass:"fill-height bg-gray-50",attrs:{"id":"accommodationMap"},on:{"click":_vm.openGoogleMaps}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }